import React, { useMemo, useCallback } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const RecipientCorrespondentAccount: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterRecipientCorrespondentAccount') },
			{
				validator(_, value) {
					if (!value || value.length === 20 || value.length === 25) {
						return Promise.resolve();
					}
					return Promise.reject(
						new Error(t('enterRecipientCorrespondentAccountShouldContainCertainNumberOfDigits')),
					);
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 25);
			onChange(onlyDigits);
			return onlyDigits;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="RecipientCorrespondentAccount"
			name={`recipientCorrespondentAccount-${setId}`}
			label="recipientCorrespondentAccountLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
